<template>
  <div class="match-2023p match-common">
    <div id="app">
      <el-row class="banner-img" onclick='javascript:window.open("http://univ.ciciec.com","_blank")'>
        <img src="@/assets/myMatch/2025/no9_banner.png"></img>
      </el-row>
      <!-- 赛事简洁 -->
      <el-row class="pd60-0204" id="ssjj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204">
            <span class="title-font28-span">赛事简介</span>
          </el-row>
          <div class="ins-box">
            <img class="fpga-ins-img" src="@/assets/myMatch/2025/ssjj-img.png" alt="" />
            <el-row class="ins-text-fpga">
              <div>
                2025年1月中旬，第九届全国大学生集成电路创新创业大赛启动仪式在上海临港举行。该活动由工业和信息化部人才交流中心主办，中国（上海）自由贸易试验区临港新片区管理委员会、同济大学指导，上海临港新工科产教融合研究院承办，上海临港海洋高新技术产业发展有限公司、上海海洋大学、IEEE中国代表处、北京电子学会协办，北京智芯国信科技有限公司运营。
              </div>
              <br />
              <div>
                在本届大赛中，海云捷迅参与赛题设置，以产业实践赋能高校人才培养，助力参赛团队成长。
              </div>
            </el-row>
          </div>
        </el-row>
      </el-row>
      <!-- 精彩资讯 -->
      <el-row class="pd60-0204" id="jczx-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204 title-font28-0204-margin"><span
              class="title-font28-span">精彩资讯</span></el-row>
          <div class="news-box">
            <div class="news-card">
              <div class="n-title" @click="goToNews('/news/enterprise/detail?id=10046')">第九届集创赛全国总决赛圆满落幕，海云捷迅助力未来芯才成长
              </div>
              <div class="n-cont">2025年8月24日，第九届全国大学生集成电路创新创业大赛全国总决赛颁奖典礼在上海临港新片区顺利举行。本届大赛由工业和信息化部人才交流中心主办</div>
              <div class="n-date">2025-08-28</div>
            </div>
            <div class="news-card">
              <div class="n-title" @click="goToNews('/news/enterprise/detail?id=10041')">开启决赛序幕——第九届集创赛华北分赛区决赛成功举办</div>
              <div class="n-cont">2025年7月23日至25日，由工业和信息化部人才交流中心主办的第九届全国大学生集成电路创新创业大赛（以下简称“集创赛”）华北分赛区决赛在中国海洋大学（西海岸校区）成功举办
              </div>
              <div class="n-date">2025-08-01</div>
            </div>
            <div class="news-card">
              <div class="n-title" @click="goToNews('/news/enterprise/detail?id=10017')">
                第九届集创赛海云捷迅杯赛题解析出炉，大赛报名火热进行中，诚邀您一展风采！</div>
              <div class="n-cont">FPGA与AI的结合正在重塑芯片生态，通过灵活可编程的架构和高并行计算能力，FPGA在AI推理加速、边缘计算和实时数据处理（如自动驾驶、工业自动化）等领域展现显著优势
              </div>
              <div class="n-date">2025-04-02</div>
            </div>
          </div>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a href="http://univ.ciciec.com" target="_blank" class="title-link">进入集创赛官网了解更多</a>
            </div>
          </el-row>
        </el-row>
      </el-row>

      <!-- 海云捷讯杯 -->
      <div id="awcloudCup">
        <div class="awcloudCup_center">
          <!-- 海云捷迅杯 -->
          <div class="awcloudCup_title">
            <div class="awcloudCup_titleTop">
              <div class="title-font28-0204 title-font28-0204-margin">
                <span class="title-font28-span">海云捷迅杯</span>
              </div>
            </div>
            <div class="awcloudCup_titleBottom">
              海云捷迅作为企业代表参与赛题设置，大赛中开设"海云捷迅杯"赛道
            </div>
          </div>
          <!-- 杯赛题目 -->
          <div class="awcloudCup_subject topic-box">
            <div class="topic-item left">
              <div class="topic-top">
                <div class="awcloudCup_subjectImg"></div>
                <span>杯赛题目</span>
              </div>
              <div class="topic-bottom">
                基于FPGA的机械臂精确控制系统设计
              </div>
            </div>
            <div class="topic-item">
              <div class="topic-top">
                <div class="awcloudCup_subjectImg"></div>
                <span>参赛组别</span>
              </div>
              <div class="topic-bottom">
                A组、B组
              </div>
            </div>
          </div>
          <!-- 设计任务 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>赛题任务</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                本赛项涉及的机械臂精确控制系统是工业自动化和智能制造关键技术，随着机械臂在工业、特种机器人、医疗、服务型机器人中越来越广泛的应用，对机械臂控制系统的功能、性能要求越来越高。多自由度机械臂的控制精度、稳定性、灵活性对于机械臂的应用有十分重要的意义。
              </li>
              <li>
                本次杯赛要求选手使用指定的FPGA开发套件控制多自由度机械臂完成将一定数量含有不同形状和颜色图案的正方形物块按照指定规则进行仓库至目的地的移动、拼接和还原。
              </li>
              <li>
                选手根据自身能力选择合适的难度，并进行方案设计，完成物体取放、移动路线计算、规划等功能实现，对机械臂进行精确控制，将物体移动到目的地并按照要求进行排列。
              </li>
            </ul>
          </div>
          <!-- 设计指标 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>设计指标</div>
            </el-row>
            <ul class="awcloudCup_taskBottom">
              <li>
                1.本赛题的基本完成要求为：完成难度1的要求；
              </li>
              <li>
                2.为激励参赛队伍选择高难度，完成难度2的参赛队伍正确完成的正方形物块数量将进行综合评分，例如若选择难度2且能最终正确完成10个正方形物块，则难度1能最终正确完成的正方形物块数量也为10，得分将相加；
              </li>
              <li>
                3.参赛团队所实现的功能使用RTL实现的均认定为优于非FPGA实现，比如：使用RTL实现机器视觉识别得分优于外接算力平台进行机器视觉识别。视觉识别算法不一定是神经网络算法。
              </li>
            </ul>
          </div>
          <!-- 附加题 -->
          <div class="awcloudCup_task" style="padding-bottom: 45px">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>附加题</div>
            </el-row>
            <div class="awcloudCup_taskBottomTable">
              <table>
                <thead>
                  <tr>
                    <th class="awcloudCup_taskBottomPerformance">分值</th>
                    <th class="awcloudCup_taskBottomScore">说明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-center">20分</td>
                    <td>
                      根据外接算力平台的选择以及实现功能进行评分。若外接算力平台为FPGA，则可得部分附加分，另外根据在外接算力平台上实现的功能进行酌情加分；若外接算力平台为除FPGA以外的处理器，则附加分为0。
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 提交内容 -->
          <div class="awcloudCup_task">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>提交内容</div>
            </el-row>
            <div class="submit-cont">
              <div class="sub-item">
                <div class="title">初赛阶段</div>
                <div class="cont">
                  1.汇报PPT：<br/>
                  （1）项目介绍<br/>
                  （2）关键技术介绍<br/>
                  （3）性能指标（目标锁定时间、定位精度、移动速度等）<br/>
                  2.详细设计方案：<br/>
                  （1）系统架构分析<br/>
                  （2）关键技术分析<br/>
                  （3）性能分析（目标锁定时间、定位精度、移动速度等）<br/>
                  3.测试报告<br/>
                  4.工程源码<br/>
                  5.效果演示视频
                </div>
              </div>

              <div class="sub-item">
                <div class="title">分赛区决赛及总决赛阶段</div>
                <div class="cont">
                  1.现场汇报PPT：<br/>
                  （1）项目介绍<br/>
                  （2）关键技术介绍、提升点、数据统计<br/>
                  （3）仿真及测试过程例证、呈现<br/>
                  （4）性能指标（目标锁定时间、定位精度、移动速度等）<br/>
                  2.详细设计方案：<br/>
                  （1）系统架构分析<br/>
                  （2）关键技术分析<br/>
                  （3）性能分析（目标锁定时间、定位精度、移动速度等）<br/>
                  3.测试报告<br/>
                  4.现场效果演示
                </div>
              </div>
            </div>
          </div>
          <!-- 评分标准 -->
          <div class="awcloudCup_task" style="padding-bottom: 45px">
            <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
              <div class="content-col18-bg"></div>
              <div>评分标准</div>
            </el-row>
            <!-- 评分标准表 -->
            <div class="awcloudCup_SorePip">
              <table>
                <thead>
                  <tr>
                    <th width="200px">项目</th>
                    <th width="200px">内容</th>
                    <th width="120px">分值</th>
                    <th>评分要求</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      基本指标(20分)
                    </td>
                    <td rowspan="2">可正常运行</td>
                    <td>5分</td>
                    <td>系统正常运行，能正常完成机械臂控制</td>
                  </tr>
                  <tr>
                    <td>0分</td>
                    <td>系统无法正常运行</td>
                  </tr>
                  <tr>
                    <td>能正确完成难度1的要求</td>
                    <td>15分</td>
                    <td>每完成一个正方形物块加1.5分，满分15分。</td>
                  </tr>

                  <tr>
                    <td rowspan="2" class="awcloudCup_SorePipBac">
                      性能指标(50分)
                    </td>
                    <td>能正确完成难度2的要求</td>
                    <td>30分</td>
                    <td>
                      每完成一个正方形物块加2分，满分30分。
                    </td>
                  </tr>

                  <tr>
                    <td>完成图片摆放的总时间</td>
                    <td>20分</td>
                    <td>
                      按照移动耗时进行排名，得分从0分到20分按排名均布。总耗时不超过5分钟，超过5分钟按当前完成正方形物块数量进行相应排名。
                    </td>
                  </tr>

                  <tr>
                    <td rowspan="3" class="awcloudCup_SorePipBac">
                      设计完整性(20分)
                    </td>
                    <td>设计方案</td>
                    <td>6分</td>
                    <td>设计方案原理合理、逻辑清晰</td>
                  </tr>

                  <tr>
                    <td>测试报告</td>
                    <td>6分</td>
                    <td>
                      详细且充分的测试报告；<br />
                      对整个方案实现提供详尽的数据支撑
                    </td>
                  </tr>

                  <tr>
                    <td>工程源码</td>
                    <td>8分</td>
                    <td>工程源码完整；<br/>
                      进行详尽的注释说明</td>
                  </tr>

                  <tr>
                    <td rowspan="4" class="awcloudCup_SorePipBac">
                      汇报及答辩(20分)
                    </td>
                    <td>汇报PPT</td>
                    <td>5分</td>
                    <td>汇报PPT重点突出、条理清晰</td>
                  </tr>

                  <tr>
                    <td>方案描述</td>
                    <td>5分</td>
                    <td>方案原理分析合理、逻辑清晰</td>
                  </tr>

                  <tr>
                    <td>测试描述</td>
                    <td>5分</td>
                    <td>
                      对开发过程中测试进行合理描述，对方案实现过程进行数据支撑，描述简单明了、抓住重点
                    </td>
                  </tr>

                  <tr>
                    <td>现场表现</td>
                    <td>5分</td>
                    <td>体现团队协作分工，答辩和文档表现优秀。</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <el-row>
                <div style="margin: 60px 0;background-color: #ccc;" class="btn-gwbm">报名已结束</div>
            </el-row> -->
        </div>
      </div>

      <!-- FPGA培训 -->
      <el-row class="pd60-0204 fpga-wrapper" id="fpga-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204"><span class="title-font28-span">FPGA培训</span></el-row>
          <el-row class="title-text-fpga">
            FPGA培训以FPGA人工智能方向为主，依托业内领先的FPGA技术，为人工智能及大数据、云计算等关联领域培养技能型人才。 
            培训以企业全案例训练为主要特色，面向学员有针对性的提供FPGA培训课程，课程直切企业需求，培养软件+硬件复合型人才，旨在为行业培养实战型专业人才。 
            FPGA培训将就业贯穿学员培养的全过程，实现学员个人职业生涯的可持续发展；依托海云捷迅人工智能领域的合作伙伴及FPGA生态企业，组织专场招聘会和双选会，为企业输送优秀人才，保障学员就业。
          </el-row>
          <el-row>
            <ul class="fpga-img">
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-one"></div>
                <div class="fpga-bottom-title">课堂教学</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-two"></div>
                <div class="fpga-bottom-title">专场招聘</div>
              </li>
              <li class="fpga-li">
                <div class="fpga-bg-box fpga-bg-three"></div>
                <div class="fpga-bottom-title">生活学习</div>
              </li>
              <li class="fpga-li" style="margin-right: 0px">
                <div class="fpga-bg-box fpga-bg-four"></div>
                <div class="fpga-bottom-title">素质拓展</div>
              </li>
            </ul>
          </el-row>
          <el-row style="margin-top: 30px">
            <div class="title-button">
              <a href="https://fpgaba.com/" target="_blank" class="title-link">了解更多培训信息</a>
            </div>
          </el-row>
        </el-row>
      </el-row>
      <!-- 实训场景 -->
      <el-row class="pd60-0204 sx-wrapper" id="sxcj-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204"><span class="title-font28-span">实训场景</span></el-row>
          <el-row class="sx-box">
            <div class="sx-left sx-bg-one"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>农业智联网实训沙盘</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训场景是以农业大棚为背景定制的一套微缩立体沙盘，涵盖人工智能、物联网、FPGA、Web开发等技术领域，
                可实现包括人工智能机器视觉技术的农作物病害检测、传感器数据收集及分析、FPGA入侵检测和反向自动控制等功能。
                通过可视化的监控大屏、移动端APP实现对大棚环境实时显示、状态查询、远程控制等操作。结合教学内容与实际产业、岗位需求，
                该实训套件能提供丰富的实验课程及配套资源，让学生快速掌握相关技能知识，加强对行业需求的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box">
            <div class="sx-left sx-bg-two"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>工业缺陷检测实训套件</div>
              </el-row>
              <div class="sx-title">
                工业缺陷检测实训套件是以工业互联网铝表面缺陷检测应用为背景，面向高校人工智能、FPGA等相关专业的实训产品。
                为贴合真实应用场景，本产品加入专业的工业相机、光源、传送带、机械臂形成一套完整的智能检测应用系统，实现基于FPGA的数据推理、机械臂自动分拣和检测数据可视化展示等功能。
                产品利用YOLOv3深度学习算法和铝片表面缺陷数据集，并使用FPGA来运行模型应用，可检测铝表面划痕、针孔、褶皱、污损等4种缺陷类型，用户可二次开发增加缺陷种类。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-three"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>农业智联网实训套件</div>
              </el-row>
              <div class="sx-title">
                农业智联网实训套件结合传感器数据采集、数据传输、图像处理、智能化分析、反向自动控制等技术，通过监控大屏对农作物环境信息进行可视化展示，
                并将历史环境数据生成曲线走势图，方便用户直观了解环境变化趋势，也可以通过监控大屏的灯光控制按钮反向控制灯光照明。
                针对农作物种植过程中的病害问题，使用农作物病害样本集，基于YOLOv3算法模型训练得到农作物病害识别的智能算法模型，利用VPU芯片进行农作物病害实时检测并在大屏中展示检测结果，显示病因并提出防治方法。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-four"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>病害检测系统</div>
              </el-row>
              <div class="sx-title">
                病害检测系统是以农作物健康状态检测为背景，基于人工智能技术方向提供的软硬一体化实训产品。
                产品使用农作物病害样本集，利⽤YOLOv3⽬标检测算法进行训练，将最终输出模型作为系统的检测分类器，通过VPU芯片对农作物病害情况进行实时检测。
                当摄像头采集到农作物叶子图像时，系统可自动判叶子的种类及病害情况，并在Web页面对病害状况进行可视化展示。
                对有病害的农作物，通过文字标注相应的病害名称和防治方法，帮助农户做好病害预警。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-five"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>无人车实训套件</div>
              </el-row>
              <div class="sx-title">
                无人车实训套件是集自动控制、人工智能、FPGA、视觉计算等技术领域，面向高校人工智能相关专业提供的软硬一体的教学实训产品。
                系统搭载ARM、GPU、FPGA三大异构算力芯片，整合了ROS机器人操作系统平台，利用雷达测距原理、SLAM即时定位与地图构建、视觉计算、深度学习技术，
                实现无人车自动驾驶、交通标识牌识别、路径规划、目标跟踪等功能。
                支持通过手机APP对无人车进行状态查询和线路构建。
              </div>
            </div>
          </el-row>
          <el-row class="sx-box" v-if="showMore">
            <div class="sx-left sx-bg-six"></div>
            <div class="sx-right">
              <el-row class="content-col18" style="width: 100%; margin-bottom: 0">
                <div class="content-col18-bg"></div>
                <div>画像风格迁移系统</div>
              </el-row>
              <div class="sx-title">
                画像风格迁移系统内置画像风格迁移（Fast-style-transfer）算法，对摄像头采集的真实图像和输入的风格图像通过神经网络深度运算，渲染成具有艺术风格迁移的图像，
                并通过画屏对风格迁移后的画像进行可视化展示。用户可通过照片打印机，对渲染后的画像快速打印成照片用作留念。结合该产品，可以帮助学生掌握画像风格迁移基础知识，熟悉模型依赖环境，
                了解模型推理过程，学习处理数据集方法，加深对图像处理、人工智能等技术的理解和认知。
              </div>
            </div>
          </el-row>
          <el-row style="
              margin-top: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
            <div class="sx-botton" @click="showMore = !showMore">{{ showMore ? '收起' : '展开更多' }}</div>
            <img v-if="!showMore" src="@/assets/myMatch/ciciec2023/sxcj_btn_unfold.png" alt=""
              class="sxcj-btn-unfold" />
            <img v-if="showMore" src="@/assets/myMatch/ciciec2023/sxcj_btn_fold.png" alt=""
              class="sxcj-btn-fold hide" />
          </el-row>
        </el-row>
      </el-row>
      <!-- 硬件说明 -->
      <el-row class="pd60-0204 sspt-wrapper" id="sspt-mlj">
        <el-row class="w1160-0204">
          <el-row class="title-font28-0204 title-font28-0204-margin"><span
              class="title-font28-span">硬件说明</span></el-row>
          <el-row class="intro-title">AWC_C4 FPGA开发套件（青春版）</el-row>
          <div class="intro-cont">
            <div class="left-text">
              <span>
                AWC_C4 FPGA开发套件（青春版）是由海云捷迅研发的一款全面支持 FPGA 基础实验的高性价比开发套件。板卡设计以 FPGA 教学为基础，配备诸如LED、按键、拨码开关、七段数码管等基础外设，
                用于 FPGA 入门级学习。同时为激发学生的学习兴趣，可以使用 RGB 三色发光二极管阵列、OLED、温湿度传感器、蜂鸣器等外设进行可视化、交互式的设计。另外，对于创新能力较强的学生，
                还可使用SDRAM、以太网接口、TF卡接口、VGA接口、摄像头接口、ADC/DAC、用户扩展IO等进行更为复杂的设计和开发。
              </span><br/>
              <div class="text-flex">
                <span>
                  1.  板载USB-Blaster 二代下载线，提高开发效率；<br/>
                  2.  经典款FPGA、学习资源超多；<br/>
                  3.  逻辑资源：6K LEs；<br/>
                  4.  可用GPIO：179个；</span>
                <span>
                  5.  270Kb内嵌Memery；<br/>
                  6.  15个18*18乘法器；<br/>
                  7.  丰富的外设资源。
                </span>
              </div>
            </div>
            <div class="right-img">
              <img src="@/assets/myMatch/2025/hardware-img1.png"></img>
            </div>
          </div>
          <div class="hardware-img"><img src="@/assets/myMatch/2025/hardware-img2.png"></img></div>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMore: false,
    };
  },
  mounted() {
  },
  methods: {
    goToNews(url) {
      this.$router.push(url)
    }
  },
};
</script>